module.exports = __webpack_public_path__ + "img/refund.dfb16c6e.svg";